<div class="layout-footer">
    <div class="footer-start">
        <img
               src="assets/layout/images/favicon-wow.png"

            alt="logo"
        />
        <span class="app-name">WowInventory</span>
    </div>
    <div class="footer-end">
        <!-- <span>© Childcare WoW</span> -->
        <span>© Wow Inventory</span>
    </div>
</div>
